/* eslint-disable */

export enum HappyCustomerType {
  NOT_USED = 0,
  GLOBAL = 1,
  COUNTRY = 2,
  STORE = 3,
  UNRECOGNIZED = -1,
}

export interface HappyCustomerScore {
  type: HappyCustomerType;
  region: string;
  businessUnitCode: string;
  month: number;
  year: number;
  notificationHigh?: boolean | undefined;
  digital: number;
  digitalYtd: number;
  digitalGoal: number;
  physical: number;
  physicalYtd: number;
  physicalGoal: number;
  services: number;
  servicesYtd: number;
  servicesGoal: number;
  support: number;
  supportYtd: number;
  supportGoal: number;
  topline: number;
  toplineGoal: number;
  toplineYtd: number;
  product: number;
  productYtd: number;
  productGoal: number;
  performanceDeviationWeek?: number | undefined;
}

export interface HappyCustomerScoreResponse {
  item: HappyCustomerScore | undefined;
}

export interface HappyCustomerScoreRequest {
  unitName: string;
}

export interface HappyCustomerScoreImportRequest {
}
